// L'impronta del sorgente da cui è nato il PDF che stai guardando.
//
// Serve a rispondere in tempo reale a «quello che vedo è ancora quello che ho
// scritto?». Un flag «sporco» risponderebbe male: dopo aver scritto una lettera
// e averla cancellata, il testo è tornato quello di prima e l'anteprima è di
// nuovo buona — un flag resterebbe acceso a dire il falso. Il confronto è
// sull'IMPRONTA, quindi torna a posto da sé.
//
// FNV-1a a 32 bit, e non SHA-256: qui non ci si difende da nessuno, si nota una
// differenza. E soprattutto è SINCRONA: il confronto si fa a ogni battuta,
// dentro il render, dove una promessa costringerebbe a tenere in piedi uno
// stato in più che può restare indietro rispetto al testo.

export function impronta(testo: string): string
{
    let h = 0x811c9dc5;

    for (let i = 0; i < testo.length; i++)
    {
        h ^= testo.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }

    return (h >>> 0).toString(16).padStart(8, "0");
}
